<template>
    <Card>
        <div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 350px" class="yl-flex flex_between">
                    <Input placeholder="搜索客户姓名/手机号/城市" v-model="name" style="width: 250px">
                        <i-button slot="append" icon="ios-search" @click="search"></i-button>
                    </Input>
                </div>
            </div>
            <div class="sousuo" style="width: 100%">
                <div style="width: 350px" class="yl-flex flex_between">
                    <Select v-model="status" placeholder="状态" style="width: 250px">
                        <Option v-for="item in statusFilters" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                    <Select v-model="medium_code_id" placeholder="媒体代码" style="width: 300px;padding-left: 20px;">
                        <Option v-for="item in srcList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                    <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                    <Button class='ivu-btn-circle' type="primary" @click="initSearch">重置</Button>
                </div>
            </div>
            <div class="multiple">
                <div class="child-div">申请时间</div>
                <RadioGroup v-model="timePeriod">
                    <Radio label="0"><span>不限</span></Radio>
                    <Radio label="1"><span>今日</span></Radio>
                    <Radio label="2"><span>昨日</span></Radio>
                    <Radio label="3"><span>本周</span></Radio>
                    <Radio label="4"><span>上周</span></Radio>
                    <Radio label="5"><span>本月</span></Radio>
                    <Radio label="6"><span>上月</span></Radio>
                    <Radio label="7"><span>自定义</span></Radio>
                    <DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
                                placeholder="选择日期" style="width: 200px"></DatePicker>
                </RadioGroup>
            </div>

            <div class="yl-flex flex_between" style="margin-top: 10px; align-items: center">
                <div class="statics">
                    <span class="black plus">数据统计</span>
                    <span><p class="black">线索总数</p>:<p>{{count}}条</p></span>
                    <span><p class="black">占比情况</p></span>
                    <span><p class="black">0星</p>:<p>{{start0}}%</p></span>
                    <span><p class="black">1星</p>:<p>{{start1}}%</p></span>
                    <span><p class="black">2星</p>:<p>{{start2}}%</p></span>
                    <span><p class="black">2+星</p>:<p>{{start2More}}%</p></span>
                    <span><p class="black">3星</p>:<p>{{start3}}%</p></span>
                    <span><p class="black">4星</p>:<p>{{start4}}%</p></span>
                </div>
            </div>
            <div style="width: 100% ;margin-top: 20px;">
                <Table :columns="columns" :data="datas" size="small" ref="table">
                    <template slot-scope="{ row }" slot="entrust">
                        <div v-for="(item,index) in row.entrust" style="margin: 3px 0" :key="index">{{item.created_at}} {{item.content}}</div>
                        <div v-if="row.entrust.length == 0">无</div>
                    </template>
                    <template slot-scope="{ row }" slot="operation">
                        <div>
                            <div style="display: flex; flex-direction: column; align-items: center;">
                                <span v-if="row.can_count == 1" style="color: #63B3E6; cursor: pointer;" @click.stop="countDown" :data-id="row.id">结算</span>
                                <span v-else style="color: #63B3E6; cursor: pointer;">--</span>
                            </div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="recordings">
                        <div v-if="row.recordings && row.recordings.length > 0">
                            <div v-for="(recording, index) in row.recordings" :key="recording.id" class="recording-item">
                                <span @click="playRecording(row.id, recording.url, recording.created_at)" style="color: #1890ff; cursor: pointer;">
                                    播放{{index + 1}} ({{formatDateTime(recording.created_at)}})
                                </span>
                            </div>
                        </div>
                        <div v-else>无录音</div>
                    </template>
                </Table>
            </div>
            <div class="pager">
                <Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
                    :current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
            </div>
        </div>
    </Card>
</template>
<script>
import { mapGetters } from "vuex";
import { getMediumCountList, countDownClient } from "../../api/finance";

export default {
    name: "MediumCount",
    components: {},

    data() {
        return {
            count: 0,
            page: 1,
            pageSize: 10,
            pageSizeOpts: [10, 50, 100, 200, 500],
            name: "",
            timePeriod: "1",
            timePeriodDate: "",
            status: [],
            srcList: [],
            statusFilters: [
                { label: "未处理", value: "1" },
                { label: "待跟进", value: "2" },
                { label: "邀约中", value: "3" },
                { label: "上门未签约", value: "6" },
                { label: "已签约", value: "7" },
                { label: "进件中", value: "8" },
                { label: "银行拒绝", value: "9" },
                { label: "已回款", value: "13" },
                { label: "资质不符", value: "14" },
                { label: "捣乱申请", value: "15" },
                { label: "外地申请", value: "16" },
                { label: "重复申请", value: "17" }
            ],
            datas: [],
            columns: [
                { type: "selection", width: 50, align: "center" },
                { title: "客户", key: "name", align: "center" },
                { title: "手机号", key: "phone", align: "center" },
                { title: "订单号", key: "order_id", align: "center" },
                { title: "媒体代码", key: "medium_code_name", align: "center" },
                { title: "城市", key: "city", align: "center" },
                { title: "需求额度", key: "loans_money", align: "center" },
                { title: "星级", key: "start_name", align: "center" },
                { title: "申请时间", key: "applied_at", align: "center", sortable: true },
                { title: "查看录音", align: "center", slot: "recordings", width: 120 }
            ],
            start_columns: [
                { type: "selection", width: 50, align: "center" },
                { title: "0星", key: "name", align: "center", width: 120 },
                { title: "1星", key: "phone", align: "center", width: 120 },
                { title: "2星", key: "medium_code_name", align: "center" },
                { title: "2星+", key: "city", align: "center" },
                { title: "3星", key: "loans_money", width: 80 },
                { title: "4星", key: "start_name", width: 60 }
            ],
            start0: 0,
            start1: 0,
            start2: 0,
            start2More: 0,
            start3: 0,
            start4: 0,
            unCountRecharge: 0,
            countRecharge: 0,
            medium_code_id: "",
            currentAudioUrl: ""
        };
    },

    computed: {
        ...mapGetters(["token", "userInfo"])
    },

    mounted() {
        this.getList();
    },

    beforeDestroy() {
        this.currentAudioUrl = "";
    },

    methods: {
        timePeriodDateChange(e) {
            this.timePeriodDate = e;
        },

        async getList() {
            const that = this;
            const data = {
                limit: that.pageSize,
                page: that.page,
                token: that.token,
                timePeriod: that.timePeriod,
                timePeriodDate: that.timePeriodDate,
                name: that.name,
                status: that.status,
                medium_code_id: that.medium_code_id
            };
            const res = await getMediumCountList(that, data);
            if (res.code === 1) {
                that.datas = res.data.list;
                that.srcList = res.data.medium_code_list;
                that.start0 = res.data.start0;
                that.start1 = res.data.start1;
                that.start2 = res.data.start2;
                that.start2More = res.data.start2More;
                that.start3 = res.data.start3;
                that.start4 = res.data.start4;
                that.unCountRecharge = res.data.unCountRecharge;
                that.countRecharge = res.data.countRecharge;
                that.count = res.count;

                // 处理录音数据（直接为数组）
                that.datas.forEach(item => {
                    item.recordingItems = item.recordings || [];
                });
            }
        },

        search() {
            this.page = 1;
            this.getList();
        },

        initSearch() {
            this.name = "";
            this.timePeriod = "1";
            this.page = 1;
            this.status = [];
            this.medium_code_id = "";
            this.getList();
        },

        changePage(e) {
            this.page = e;
            this.getList();
        },

        changeSize(e) {
            this.pageSize = e;
            this.getList();
        },

        // 结算功能
        countDown(e) {
            const that = this;
            const id = e.currentTarget.dataset.id;
            that.$Modal.confirm({
                title: "确认结算吗？",
                onOk: async () => {
                    that.throttle(async () => {
                        const data = { token: that.token, id };
                        const res = await countDownClient(that, data);
                        if (res.code === 1) {
                            that.$Message.success(res.msg);
                        }
                        that.getList();
                    }, 500);
                }
            });
        },

        countDownBatch() {
            const that = this;
            const selection = this.$refs.table.getSelection();
            const ids = [];
            selection.forEach(e => {
                ids.push(e.id);
            });
            that.$Modal.confirm({
                title: "确认批量结算吗？",
                onOk: async () => {
                    that.throttle(async () => {
                        const data = { token: that.token, id: ids };
                        const res = await countDownClient(that, data);
                        if (res.code === 1) {
                            that.$Message.success(res.msg);
                        }
                        that.getList();
                    }, 500);
                }
            });
        },

        // 格式化日期时间
        formatDateTime(value) {
            if (!value) return "";
            try {
                const date = new Date(value.replace(/-/g, '/').replace('T', ' ').replace('Z', ''));
                return date.toLocaleString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });
            } catch (e) {
                return value;
            }
        },

        // 播放录音（最终解决方案）
        playRecording(clientId, url, createdAt) {
            this.currentAudioUrl = url;
            
            // 显示播放模态框（使用HTML字符串）
            this.$Modal.info({
                title: `客户ID: ${clientId} 的录音 (${createdAt})`,
                content: this.createAudioHTML(url),
                width: 400,
                onOk: () => {
                    this.currentAudioUrl = "";
                }
            });
        },
        
        // 生成音频播放器的HTML字符串
        createAudioHTML(url) {
            return `
                <div style="padding: 10px 0; text-align: center;">
                    <audio src="${url}" controls style="width: 100%; max-width: 360px;">
                        <p>您的浏览器不支持音频播放，请使用现代浏览器</p>
                    </audio>
                </div>
            `;
        },

        // 节流函数（原有功能保留）
        throttle(func, wait) {
            let timeout;
            return function() {
                const context = this;
                const args = arguments;
                if (!timeout) {
                    timeout = setTimeout(() => {
                        timeout = null;
                        func.apply(context, args);
                    }, wait);
                }
            };
        }
    }
};
</script>
<style scoped lang="less">
.yellow_btn {
    color: #F8BD66;
}

.multiple {
    display: flex;
    justify-content: left;
    margin-top: 10px;
    align-items: center;

    .child-div {
        width: 70px;
        height: 20px;
        margin-right: 30px;
        text-align-last: justify;
    }
}

.sousuo {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.yl-flex {
    display: flex;
}

.flex_between {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.statics {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 55%;
    p {
        display: inline-block;
    }
    .black {
        color: black;
        font-weight: bold;
        padding: 0 2px;
    }
    .plus {
        font-size: 16px;
    }
}

.countDown {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 26%;
    .blue {
        color: #54A1F3;
    }
    .red {
        color: red;
    }
}

.recording-item {
    margin: 5px 0;
    cursor: pointer;
    white-space: nowrap;

    &:hover {
        text-decoration: underline;
    }
}
</style>